export { default as PromoRollCardKuper } from './PromoRollCardKuper'
